import z from 'zod';
import arrayEntry from './arrayEntry.js';
import internationalizedArrayOptionalImageValue from '../objects/internationalizedArrayOptionalImageValue.js';
var id = 'internationalizedArrayOptionalImage';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'internationalizedArrayOptionalImageValue'
        }
    ]
};
var validator = z.array(internationalizedArrayOptionalImageValue.validator.merge(arrayEntry.validator));
export default {
    id: id,
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayOptionalImage.js.map